export const SCROLL_TO_PRICE = 'SCROLL_TO_PRICE';
export const SCROLL_TO_REVIEWS = 'SCROLL_TO_REVIEWS';
export const SCROLL_TO_SECTION = 'SCROLL_TO_SECTION';
export const TOGGLE_SHORT_INFO = 'TOGGLE_SHORT_INFO';
export const SHOW_PAGE = 'SHOW_PAGE';
export const SET_SEARCH_TYPE = 'SET_SEARCH_TYPE';

export const QUERY_MOBILE_APP_ROOM_OFFERS = 'mobile_app_room_offers';
